export default __webpack_public_path__ + "static/column-with-negative-values-4496b90e0d2a53f01d732d420d6d768f.png";